export const pontoEletronicoSelect = [
'Instalação de Relógio Eletrônico de Ponto (REP)',
'Problema com Tratamento de Ponto',
'Problema com Banco de Horas',
'Problema com Relógio Eletrônico de Ponto (REP)',
'Solicitação de Bobina',
'Outros',
]